module.exports = __webpack_public_path__ + "static/media/DarwinDark.61e4c6ee.svg";